module.exports = __webpack_public_path__ + "img/psb.0ab24cca.png";